import React, { useState, useRef } from "react";
import AboutBannerImage1 from "../../src/assets/images/aboutbanner1.png";
import AboutBannerImage2 from "../../src/assets/images/aboutbanner2.jpeg";
import AboutBannerImage3 from "../../src/assets/images/dna1.png";
import CustomLine from "./CustomLine";
import AboutImage1 from "../../src/assets/images/image_40.png";
import AboutImage2 from "../../src/assets/images/image_41.png";
import AppoinmentModal from "./AppoinmnetModal";
import { FaCheck } from "react-icons/fa";
import { FiVideo } from "react-icons/fi";
import { HiOutlineDesktopComputer, HiOutlineBookOpen } from "react-icons/hi";

const CourseBannerAbout = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const stickyButtonRef = useRef(null);


    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    return (
        <div className="custom-science">
            <div className="custom-padding xl-screen-padding flex gap-10 flex-col md:flex-row w-full min-h-screen bg-white">
                {/* Image section - moved to left (was right) */}
                <div className="w-full md:w-1/2 flex flex-col justify-center aboutmain">
                    {/* Single square image container */}
                    <div className="relative rounded-lg overflow-hidden mb-4">




                    </div>

                    {/* Second square image */}
                    <div className="relative rounded-lg overflow-hidden  ">
                        <div className="aspect-w-1 aspect-h-1">
                            <img
                                src={AboutBannerImage2}
                                alt="Personalized roadmap"
                                className="w-full h-full object-cover"
                            />
                        </div>

                    </div>
                </div>

                <div className="w-full md:w-1/2 flex flex-col justify-center ">

                    {/* Small Title */}
                    <p className="text-[#6BCB3D] text-sm font-semibold font-lato tracking-widest mb-3 uppercase">
                        About Nutrillion Academy
                    </p>

                    {/* Main Heading */}
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-[#2f3a40] leading-tight mb-6 font-merriweather">
                        Elevating Nutrition
                        <br />
                        Education for Everyone
                    </h2>

                    {/* Description */}
                    <p className="text-gray-500 mb-10 text-[15px] leading-relaxed max-w-lg font-lato">
                        Nutrillion is expanding its ecosystem to include a full-scale learning academy.
                        Whether you're a wellness enthusiast or a professional, our structured courses
                        and certifications will equip you with practical, science-backed knowledge.
                    </p>

                    {/* Features Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">

                        {/* Feature 1 */}
                        <div className="flex items-start gap-4">
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <HiOutlineBookOpen className="text-green-600 text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato">
                                    Science-Backed Curriculum
                                </h4>
                                <p className="text-sm text-gray-500 font-lato">
                                    Learn from up-to-date, peer-reviewed research.
                                </p>
                            </div>
                        </div>

                        {/* Feature 2 */}
                        <div className="flex items-start gap-4">
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <HiOutlineDesktopComputer className="text-gray-600 text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato">
                                    Self-Paced Learning
                                </h4>
                                <p className="text-sm text-gray-500 font-lato">
                                    Study anytime, anywhere, on any device.
                                </p>
                            </div>
                        </div>

                        {/* Feature 3 */}
                        <div className="flex items-start gap-4">
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <FiVideo className="text-gray-600 text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato">
                                    Live Sessions
                                </h4>
                                <p className="text-sm text-gray-500 font-lato">
                                    Interact with specialists in real-time Q&A.
                                </p>
                            </div>
                        </div>

                        {/* Feature 4 */}
                        <div className="flex items-start gap-4">
                            <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-gray-200 rounded-full">
                                <FaCheck className="text-green-600 text-lg" />
                            </div>
                            <div>
                                <h4 className="font-semibold text-gray-800 font-lato">
                                    Practical Assessments
                                </h4>
                                <p className="text-sm text-gray-500 font-lato">
                                    Test your knowledge with real-world scenarios.
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div>
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>

                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>


        </div>
    );
};

export default CourseBannerAbout;